<template>    
  <BaseLayout>
    <div>
      <h5><font-awesome-icon icon="address-card" class="icon"/> Registro de atividades</h5>
      <br>                    
      <div v-if="listingFormated.length" class="table" responsive="sm">
        <b-row class="tb-header">
          <b-col class="col-3">Dia da atividade</b-col>
          <b-col class="col-9">Atividade</b-col>
        </b-row>
        <b-row class="tb-line" v-for="item in listingFormated" v-bind:key="item.id" @click="showModal(item)">
          <b-col class="col-3">{{ item.created_at }}</b-col>
          <b-col class="col-9" :title="item.longTxt">{{ item.text }}</b-col>
        </b-row>
        <transition name="modal" 
          v-if="modalVisible"
          @close="modalVisible = false"
          :data="modalData">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-container">
                <button class="modal-btn" @click="closeModal">
                  x
                </button>
                <div class="modal-header">
                  <slot name="header">
                    <b>Registro de Atividade</b>
                  </slot>
                </div>
                <div class="modal-body">
                  <slot name="body">
                    {{ modalData.longTxt }}
                  </slot>
                </div>
                <div class="modal-footer">
                  <slot name="footer">
                    {{ modalData.created_at }}
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <br>
        <paginate
          :page-count="this.count"
          :click-handler="getData"
          :page-range="2"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pag-item'"
          :prev-class="'pag-item'"
          :next-class="'pag-item'"
          :prev-link-class="'pag-item'"
          :next-link-class="'pag-item'"
          :active-class="'item-on'"
          :disabled-class="'item-off'">
        </paginate>
      </div>
    </div>
    <div class="mt-5" v-show="!loaded">
      <h5 class="text-center">Você ainda não efetuou alterações</h5>
    </div>         
  </BaseLayout>    
</template>
<style scoped>
  .container[data-v-49eec20b]{
    max-width: 1200px!important;
  }
  .tb-header{
    border: 1px solid #dcf1ff;
    padding: 5px 5px;
    border-radius: 15px 15px 0 0;
    background-color: #e2ecf3;
    font-weight: 600;
  }
  .tb-line{
    border: 1px solid #dcf1ff;
    border-radius: 15px;
    margin-top: 3px;
    padding-top: 5px;
    padding-bottom: 5px;
    cursor: pointer;
  }
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    margin: 150px auto;
  }

  .modal-container {
    width: 450px;
    margin: 0px auto;
    padding: 10px 20px 5px 20px;
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-footer{
    margin: 5px 2px;
    display: block;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 15px 0;
  }

  .modal-btn {
    position: relative;
    right: -12px;
    float: right;
    background-color: #e2ecf3;
    border: 1px solid #dcf1ff;
    border-radius: 5px;
    padding: 0px 6px;
    margin: 0;
  }
  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
</style>
<style>
  a{ outline: none; }
  .pagination li.pag-item{
    margin: 2px;
    padding: 2px 0px;
    text-align: center;
    width: 30px;
    border: 2px #e2ecf3 solid;
    border-radius: 5px;
    font-size: 14px;
    font-weight: bold;
  }
  li.pag-item.item-on{
    background-color: #e2ecf3
  }
  li.pag-item.item-off a{
    cursor: not-allowed;
  }
</style>
<script>
  import BaseLayout from '@/components/BaseLayout';
  import { mapActions, mapState, mapGetters } from 'vuex';
  import Paginate from 'vuejs-paginate';
  export default {
    data() {
      return {
        loaded: false,
        count: 0,
        modalVisible: false,
        modalData: null
      }
    },
    components: {        
      BaseLayout,
      Paginate
    },
    mounted(){
      this.getPostData();
    },
    methods:{
      ...mapActions('activityRecords', ['ActionListingActivityRecords']),
      async getPostData (){
        var data = {'per_page': 10, 'page': this.paginator.current_page};
        await this.ActionListingActivityRecords(data);
        this.loaded = true;
        this.perPage = this.paginator.per_page;
        this.current_page = this.paginator.current_page;
        this.total = this.paginator.total;
        this.count = this.getPageCount();
      },
      getData(pageNumber){
        this.paginator.current_page = pageNumber;
        this.getPostData();
      },
      getPageCount: function() {
        return(Math.ceil(this.paginator.total / this.paginator.per_page) );
      },
      showModal(data) {
        this.modalData = data;
        this.modalVisible = true;
      },
      closeModal(){
        this.modalVisible = false
      }
    },
    computed:{
      ...mapState('activityRecords', ['listing', 'paginator']),
      ...mapGetters('activityRecords', ['listingFormated'])
    }
  }
</script>